import React from 'react';
import pictureLogo from '../../../images/logo.png';
import "./DisclaimerOld.scss";
import imgDisclaimerDesktop from "./images/banner-disclamer.png";
import imgDisclaimerMobile from "./images/banner-disclamer-mobile.png";
import imgArrowDown from "./images/go-down.png";
import imgPicto14 from "./images/pictos-14.png";
import img1 from "./images/images-1.png";
import img2 from "./images/images-2.png";
import img3 from "./images/images-3.png";
import pictoFlame from "./images/flame.svg";
import picto12 from "./images/pictos-12.svg";
import {SpinLoader} from "../../components/Loader";

const DisclaimerOld = ({initialized, disclaim}) => {
    return (
        <div className="disclamer-old">
            <div className="disclamer-content">
                <div className="disclamer-content-banner">
                    <img className="banner-desktop" src={imgDisclaimerDesktop} alt="" />
                    <img className="banner-mobile" src={imgDisclaimerMobile} alt="" />
                </div>
                <div className="disclamer-content-info">
                    <div className="disclamer-content-info-logo">
                        <img src={pictureLogo} alt="" />
                        <p>Le plus bel espace de liberté</p>
                    </div>
                    <div className="disclamer-content-info-age">
                        <p>Le contenu de Voissa est <b>réservé aux adultes</b>.</p>
                        <p>Si vous n'avez pas encore 18 ans, l'accès est strictement interdit.</p>
                        {initialized ? (
                            <span className="disclamer-content-info-age-cta" onClick={() => disclaim()}>
                                <div className={"enter-website"}>ENTRER</div>
                                <span>(c'est gratuit !)</span>
                            </span>
                        ) : (
                            <span className="disclamer-content-info-age-cta">
                                <SpinLoader />
                            </span>
                        )}
                        <span className="disclamer-content-info-age-down" >Descendez pour en savoir plus sur Voissa</span>
                        <span className="disclamer-content-info-age-downicon" ><img src={imgArrowDown} alt="" /></span>
                    </div>

                    <div className="disclamer-content-info-section" id={"content-down"}>
                        <div className="disclamer-content-info-section-img">
                            <div className="disclamer-content-info-section-img-picto">
                                <img src={picto12} alt="" />
                            </div>
                            <img className="disclamer-content-info-section-img-illu" src={img1} alt="" />
                        </div>
                        <div className="disclamer-content-info-section-content">
                            <h1>Vous êtes libre</h1>
                            <p>Depuis 1999 Voissa offre un lieu d’échange et de partage, un lieu pour créer en toute liberté.
                                C’est l'endroit parfait pour exprimer ses désirs, se révéler et faire des rencontres.
                                Notre communauté vibre au rythme de l'ouverture, de la bienveillance et du respect, valeurs clés qui nous animent au quotidien.
                            </p>
                        </div>
                    </div>

                    <div className="disclamer-content-info-section">
                        <div className="disclamer-content-info-section-content">
                            <h1>Le grand frisson (ou le petit)</h1>
                            <p>Rejoindre Voissa, c'est débuter une nouvelle aventure, choisir de s'épanouir pleinement.<br/>
                                Que vous soyez là pour partager ou juste pour explorer, Voissa est l'espace où vous pouvez vous exprimer librement.
                                À vous de jouer !
                            </p>
                        </div>
                        <div className="disclamer-content-info-section-img">
                            <div className="disclamer-content-info-section-img-picto">
                                <img src={pictoFlame} alt="" />
                            </div>
                            <img className="disclamer-content-info-section-img-illu" src={img2} alt="" />
                        </div>
                    </div>

                    <div className="disclamer-content-info-section">
                        <div className="disclamer-content-info-section-img">
                            <div className="disclamer-content-info-section-img-picto">
                                <img src={imgPicto14} alt="" style={{ width: "43px", aspectRatio: 1, objectFit: "contain" }} />
                            </div>
                            <img className="disclamer-content-info-section-img-illu" src={img3} alt="" />
                        </div>
                        <div className="disclamer-content-info-section-content">
                            <h1>Un lieu « safe »</h1>
                            <p>Voissa est le jardin secret de milliers de membres, où l'anonymat et la sécurité sont toujours assurés.<br/>
                                Notre communauté et nos modérateurs travaillent ensemble pour maintenir une atmosphère accueillante et sûre pour tous.
                            </p>
                        </div>
                    </div>
                    <div className="disclamer-content-info-age no-box">
                        {initialized ? (
                            <span className="disclamer-content-info-age-cta" onClick={() => disclaim()}>
                                <div className={"enter-website"}>ENTRER</div>
                                <span>(c'est gratuit !)</span>
                            </span>
                        ) : (
                            <span className="disclamer-content-info-age-cta">
                                <SpinLoader />
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DisclaimerOld;